/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewRewardsAccount
 */
export interface NewRewardsAccount {
    /**
     * 
     * @type {number}
     * @memberof NewRewardsAccount
     */
    points?: number;
    /**
     * 
     * @type {number}
     * @memberof NewRewardsAccount
     */
    courierUserId?: number;
    /**
     * 
     * @type {number}
     * @memberof NewRewardsAccount
     */
    courierId?: number;
    /**
     * 
     * @type {number}
     * @memberof NewRewardsAccount
     */
    creditBalance?: number;
}

/**
 * Check if a given object implements the NewRewardsAccount interface.
 */
export function instanceOfNewRewardsAccount(value: object): value is NewRewardsAccount {
    return true;
}

export function NewRewardsAccountFromJSON(json: any): NewRewardsAccount {
    return NewRewardsAccountFromJSONTyped(json, false);
}

export function NewRewardsAccountFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewRewardsAccount {
    if (json == null) {
        return json;
    }
    return {
        
        'points': json['points'] == null ? undefined : json['points'],
        'courierUserId': json['courierUserId'] == null ? undefined : json['courierUserId'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
        'creditBalance': json['creditBalance'] == null ? undefined : json['creditBalance'],
    };
}

export function NewRewardsAccountToJSON(json: any): NewRewardsAccount {
    return NewRewardsAccountToJSONTyped(json, false);
}

export function NewRewardsAccountToJSONTyped(value?: NewRewardsAccount | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'points': value['points'],
        'courierUserId': value['courierUserId'],
        'courierId': value['courierId'],
        'creditBalance': value['creditBalance'],
    };
}

